import archiveService from '@/modules/archiveModule/services/archiveService'
import { Entity, EntitySubtype } from '@/api/resources/entity/entity'

export interface VValidateLocationLabel {
    required?: boolean,
    max?: number
}

export class ArchiveHelper {
    static getLocationLabelValidationRules(internalEntityType: Entity, internalEntitySubtype: EntitySubtype): VValidateLocationLabel {
        if (internalEntityType) {
            return {
                required: archiveService.isLocationLabelRequired(internalEntityType, internalEntitySubtype),
                max: 60
            }
        }
        return {}
    }
}
